import { TaskCategoryProgress, TaskProgressProps } from "@/interfaces/progress_types"
import { ProjectProps } from "@/interfaces/project_types"
import { ProjectProgressHeader } from "./Header"
import { SegmentedProgressBar } from "./SegmentedProgressBar"

export function ProjectProgress({project}: {project: ProjectProps}) {
    const taskProgress = project.task_progress
    const electricalProgress = taskProgress?.electrical
    const mechanicalProgress = taskProgress?.mechanical
    const plumbingProgress = taskProgress?.plumbing
    const otherProgress = taskProgress?.other

    return (
        <div className="w-full">
            <ProjectProgressHeader project={project} />

            <SegmentedProgressBar 
                taskProgress={taskProgress ?? {} as TaskProgressProps}
                electricalProgress={electricalProgress ?? {} as TaskCategoryProgress}
                mechanicalProgress={mechanicalProgress ?? {} as TaskCategoryProgress}
                plumbingProgress={plumbingProgress ?? {} as TaskCategoryProgress}
                otherProgress={otherProgress ?? {} as TaskCategoryProgress}
            />

            {/* <ProjectProgressLegend 
                electricalProgress={electricalProgress ?? { percent_complete: 0, tasks_completed: 0, tasks_total: 0 }}
                mechanicalProgress={mechanicalProgress ?? { percent_complete: 0, tasks_completed: 0, tasks_total: 0 }}
                plumbingProgress={plumbingProgress ?? { percent_complete: 0, tasks_completed: 0, tasks_total: 0 }}
                otherProgress={otherProgress ?? { percent_complete: 0, tasks_completed: 0, tasks_total: 0 }}
            /> */}
        </div>
    )
}